import React from "react";
import Icon from "../Icon";

const NAV_ICONS = {
    dashboard: "icon-dashboard",
    tickets: "icon-tickets",
    users: "icon-users",
    departments: "icon-departments",
    emails: "icon-emails",
    reports: "icon-reports",
    "embed-forms": "icon-settings",
};

const MockSidebar = ({
    navItems,
    view,
    ticketSubmenu,
    expandedMenus,
    onToggleMenu,
    onNavClick,
    onSubmenuClick,
    user,
    workspace,
    isCompact,
    iconRail = false,
    onNavToggle,
    sidebarOpen = false,
}) => (
    <aside className="clk-mk-sidemenu">
        <div className="clk-mk-sidebar-top">
            {onNavToggle && (
                <button
                    type="button"
                    className="clk-mockup-nav-toggle clk-mk-sidebar-nav-toggle"
                    onClick={onNavToggle}
                    aria-expanded={sidebarOpen}
                    aria-label="Toggle navigation"
                >
                    <Icon name="menu" size={18} />
                </button>
            )}
            <button type="button" className="clk-mk-home-button" aria-label="Dashboard home">
                <img src="/images/logo.svg" alt="Claritick" />
            </button>
        </div>

        <div className="clk-mk-sidebar-main">
            <div className="clk-mk-sidebar-workspace">
                <div className="clk-mk-sidebar-workspace-img">
                    <img src="/images/window-circles.svg" alt="" />
                </div>
                <div className="clk-mk-workspace-info">
                    <h4>{workspace.title}</h4>
                    <span>{workspace.name}</span>
                </div>
            </div>

            <div className="clk-mk-sidebar-list">
                <div className="clk-mk-sidebar-menu-title">TICKET MANAGEMENT</div>
                <ul className="clk-mk-parent-nav">
                    {navItems.map((item) => {
                        const hasChildren = item.children?.length;
                        const isExpanded = expandedMenus[item.id];
                        const isTicketsActive = item.id === "tickets" && (view === "tickets" || view === "ticket-detail");
                        const isEmbedActive = item.id === "embed-forms" && view === "embed-forms";
                        const isActive = view === item.id || isTicketsActive || isEmbedActive;
                        const showChildren = item.id === "tickets";

                        const handleParentClick = () => {
                            if (item.id === "tickets" && hasChildren) {
                                if (isCompact || iconRail) {
                                    onNavClick("tickets");
                                    return;
                                }
                                onToggleMenu(item.id);
                                return;
                            }
                            onNavClick(item.id);
                        };

                        return (
                            <li
                                key={item.id}
                                className={[
                                    isActive && !showChildren ? "is-active" : "",
                                    showChildren && isExpanded ? "show-children" : "",
                                    showChildren && isTicketsActive ? "is-active" : "",
                                ].filter(Boolean).join(" ")}
                            >
                                <button
                                    type="button"
                                    className="clk-mk-sidebar-parent"
                                    onClick={handleParentClick}
                                >
                                    <span className={`clk-mk-nav-icon ${NAV_ICONS[item.id] || ""}`} aria-hidden="true" />
                                    {!isCompact && !iconRail && (
                                        <>
                                            <span className="clk-mk-sidebar-link-text">{item.label}</span>
                                            {hasChildren && (
                                                <span className={`clk-mk-sidebar-chevron${isExpanded ? " is-open" : ""}`}>▾</span>
                                            )}
                                        </>
                                    )}
                                </button>
                                {hasChildren && isExpanded && !isCompact && !iconRail && (
                                    <ul className="clk-mk-child-nav">
                                        {item.children.map((child) => {
                                            const subActive = item.id === "tickets"
                                                && ticketSubmenu === child.id
                                                && isTicketsActive;

                                            return (
                                                <li key={child.id} className={subActive ? "is-active" : ""}>
                                                    <button
                                                        type="button"
                                                        onClick={() => onSubmenuClick(item.id, child.id)}
                                                    >
                                                        {child.label}
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="clk-mk-sidebar-userbar">
                <span className="clk-mk-user-avatar clk-mk-user-avatar--initials">{user.initials}</span>
                {!isCompact && !iconRail && (
                    <div className="clk-mk-user-info">
                        <strong>{user.name}</strong>
                        <span>{user.email}</span>
                    </div>
                )}
                {!isCompact && !iconRail && <span className="clk-mk-user-dots">⋯</span>}
            </div>
        </div>
    </aside>
);

export default MockSidebar;
